// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import AlertCmp from './components/shared/Alert.vue'
import 'swiper/dist/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Meta from 'vue-meta'
import {VueMasonryPlugin} from 'vue-masonry'

Vue.use(VueMasonryPlugin)
Vue.use(VeeValidate)
Vue.use(Meta)
Vue.use(VueAwesomeSwiper)

axios.defaults.baseURL = 'https://api.jauschneg.at'
// axios.defaults.baseURL = 'http://localhost:8888'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token')
axios.defaults.headers.get['Accepts'] = 'application/json'

// Require the main Sass manifest file
require('./assets/sass/main.scss')

// Require the Font Aweosme Sass file
require('./assets/sass/fontawesome/font-awesome.scss')

Vue.config.productionTip = false

Vue.component('app-alert', AlertCmp)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js